import { FullScreenButtonProps } from './types';
import { IconExitFullScreen } from '../atoms/IconExitFullScreen';
import { IconFullScreen } from '../atoms/IconFullScreen';

import { useTranslation } from 'react-i18next';

export const FullScreenButton = (props: FullScreenButtonProps) => {
    const { onClick, isMaximized } = props;
    const { t } = useTranslation();

    return (
        <button
            className="group/fullscreen size-12 rounded-md cursor-pointer p-1 text-white"
            type="button"
            onClick={onClick}
            data-testid="toggleFullScreenButton"
        >
            <span className="sr-only">{isMaximized ? t('Player.Button.ExitFullscreen') : t('Player.Button.Fullscreen')}</span>
            <span className="block bg-primary/50 rounded-md p-2 group-hover/fullscreen:bg-primary/95 transition-color duration-200 ease-in-out">
                {!isMaximized ? <IconFullScreen /> : <IconExitFullScreen />}
            </span>
        </button>
    );
};
